<template>
  <div class="comment__convert-item-to-epic">
    <BaseSubHeading
      class="comment__convert-item-to-epic__before"
      weight="500"
      size="medium"
      color="monochrome-05"
      darkColor="monochrome-04"
    >
      Item #{{ comment.epicAuditRecord?.before?.itemSequenceNumber }}
    </BaseSubHeading>
    <icon
      data="@icon/arrow-to.svg"
      :fill="true"
      width="var(--icon-24)"
      height="var(--icon-24)"
      color="var(--monochrome05to04)"
    />
    <BaseSubHeading
      class="comment__convert-item-to-epic__after"
      weight="500"
      size="medium"
      color="accent-03"
      darkColor="accent-200"
    >
      Epic E-{{ comment.epicAuditRecord?.after?.epicSequenceNumber }}
    </BaseSubHeading>
  </div>
</template>

<script setup lang="ts">
import { Comment } from "@/models"

defineProps({
  comment: {
    required: true,
    type: Object as () => Comment
  }
})
</script>

<style scoped lang="scss">
@import "@/assets/scss/utils/mixins/_flex";

.comment__convert-item-to-epic {
  @include flex;

  gap: var(--step1);

  &__before {
    opacity: 0.5;
  }
}
</style>
